import React from 'react';
import './Button.css';

const Button = ({
  onClick,
  type = 'button',
  variant = 'primary',
  disabled = false,
  fullWidth = false,
  additionalClass = '',
  label,
  icon = null,
}) => {
  const buttonClasses = [
    'btn',
    `btn-${variant}`,
    fullWidth ? 'btn-full-width' : '',
    additionalClass,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      onClick={onClick}
      className={buttonClasses}
      disabled={disabled}
    >
      {icon && <span className="btn-icon">{icon}</span>}
      {label}
    </button>
  );
};

export default Button;